export { default } from './es/icons/OpacityLoadingTwoTone';